export interface CompanyDetails {
  name?: string;
  email?: string;
  registration_number?: string;
  vat_number?: string;
}

function New(): CompanyDetails {
  return {
    name: '',
    email: '',
    registration_number: '',
    vat_number: '',
  };
}

export default {
  New
};
